export default process.env.NODE_ENV != "production"
  ? {
      node_api_endpoint: "",
      mock_api_endpoint: "http://192.168.0.196:5051",
      // mock_api_endpoint: "https://kyc.getcupi.com/api",
      redirect_base_url: "http://localhost:3000?",
    }
  : {
      node_api_endpoint: "https://portalapi.getcupi.",
      // mock_api_endpoint: "http://192.168.0.196:",
      mock_api_endpoint: "https://kyc.getcupi.com/api",
      Client_Id: "",
      redirect_base_url: "https://admin.getcupi.com?",
    };
